import type { App } from 'vue'
import { registerAxios } from './axios'
import { vueQuery } from './vue-query'
import { registerLayouts } from './registerLayouts'
import router from '@/router'
import pinia from '@/store'
import vuetify from '@/modules/Core/plugins/vuetify'

export function registerPlugins(app: App) {
  registerAxios(app)
  registerLayouts(app)
  app.use(pinia).use(router).use(vuetify).use(vueQuery)
}
